/**
 * Single source of truth for the flow-builder route base (`/agent/builder/:id/*`, declared in
 * `configs/routes/ai-studio.tsx`). The route definition and every URL parser that reads or
 * rewrites the `:id` segment (`getFlowIdFromUrl`, `swapBuilderPathId`) derive the prefix from
 * here, so moving the builder route is a one-line change rather than a hunt across hardcoded
 * string literals. (Navigation call sites that construct a builder URL fail loudly on a path
 * change; the parsers here would fail silently, which is why they must share this constant.)
 */
export const AGENT_BUILDER_BASE_PATH = '/agent/builder'
